import { render, staticRenderFns } from "./VendorsForm.vue?vue&type=template&id=bbe8858a"
import script from "./VendorsForm.vue?vue&type=script&lang=js"
export * from "./VendorsForm.vue?vue&type=script&lang=js"
import style0 from "./VendorsForm.vue?vue&type=style&index=0&id=bbe8858a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports